import { getURLParameter } from "../../../../lib/html5-software-library/src/ranj/util/URLUtil";
import PlatformAPIEventType from "./PlatformAPIEventType";

export default class MockApi {
    constructor(environment) {
        this._environment = environment;
        this._isPlatformInterrupted = false;
        this._responseObject = {
            statusCode: "201"
        };
        this._responseDelay = parseInt(getURLParameter('apitimeout') || 100);
        this._isTimeout = false;
    }

    getGlobalConfigurationAsync() {
        const configuration = {
            language: getURLParameter("lang") ?? "en",
            play_mode: getURLParameter("mode") ?? "assessment",
            environment: this._environment,
        };

        return new Promise(resolve => {
            setTimeout(() => resolve(configuration), this._responseDelay);
        });
    }

    getConfigurationAsync(appId) {
        const configuration = {
            language: getURLParameter("lang") ?? "en",
            interaction_state: this._load(appId),
            play_mode: getURLParameter("mode") ?? "assessment",
            environment: this._environment,
        };

        return new Promise(resolve => {
            setTimeout(() => resolve(configuration), this._responseDelay);
        });
    }

    gameInterrupted(payload) {
        if (this._isPlatformInterrupted) {
            return true;
        }

        this._isPlatformInterrupted = true;
        alert(`Game interrupted by platform!\n\nReason:\n${JSON.stringify(payload, null, 2)}`);
        return true;
    }

    sendEventAsync(eventType, payload) {
        console.log(`[MockPlatformAPIService] sendEventAsync: `, eventType, payload || "no payload");
        switch (eventType) {
            case PlatformAPIEventType.SAVE_REQUEST:
                this._save(payload.appId, payload.interaction_state);
                break;
        }
        return new Promise((resolve, reject) => setTimeout(_ => {
            if (this._isTimeout) {
                reject("MockAPI timeout");
            } else {
                resolve(this._responseObject);
            }
        }, this.responseDelay));
    }

    exit() {
        window.location.reload();
    }

    setMockResponseObject(responseObject) {
        this._responseObject = responseObject;
    }

    setMockResponseDelay(responseDelay) {
        this._responseDelay = responseDelay;
    }

    setMockTimeoutState(isTimeout) {
        this._isTimeout = isTimeout;
    }

    _save(appId, str) {
        window.localStorage.setItem(this._getCookieName(appId), str);
    }

    _load(appId) {
        return window.localStorage.getItem(this._getCookieName(appId));
    }

    _getCookieName(appId) {
        return `${appId}.saveGame`;
    }
}